import React, { useState } from 'react'
import { Col, Row, Input, Form, Button } from 'antd'
import commonStyles from '../../../Utils/Common.less'
import { SaveOutlined } from '@ant-design/icons'
import { SaveVoidThisModel } from '../../../Services/ToDoViewAllList'
import { useDispatch } from 'react-redux'
interface voidthisMolde {
    changeModelState: () => void
    serviceProcessId: number
}
const VoidThisProcess = (props: voidthisMolde): React.ReactElement => {
    const { changeModelState, serviceProcessId } = props
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [buttonLoading, setButtonloading] = useState(false)
    const onSave = (): void => {
        void onSavePhone()
    }
    const onSavePhone = async (): Promise<void> => {
        try {
            setButtonloading(true)
            await form.validateFields()

            const formData = form.getFieldsValue()

            const comments = formData.description

            const saveVoidData = {
                serviceProcessId,
                comments,
            }
            await SaveVoidThisModel(dispatch, saveVoidData)
                .then((result) => {
                    if (result !== null && result !== undefined) {
                        setButtonloading(false)
                    }
                })
                .catch(() => {})

            form.setFieldsValue({
                description: '',
            })

            changeModelState()
        } catch (error) {}
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    return (
        <div className={commonStyles.formWrapper}>
            <Form
                name="complex-form2"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                layout={'vertical'}
                autoComplete="off"
                form={form}
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Comments"
                            name="description"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Comments!',
                                },
                            ]}
                        >
                            <Input.TextArea rows={4} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col offset={21} span={2}>
                        <Button
                            type="primary"
                            size="middle"
                            onClick={onSave}
                            loading={buttonLoading}
                        >
                            <SaveOutlined />
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}
export default VoidThisProcess
